(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  const catalogueFilterState = new Map();
  const bindCatalogueFilters = (scope = document) => {
    scope.querySelectorAll('[data-catalogue-filter-root]').forEach((root) => {
      if (root.dataset.catalogueFiltersBound === 'true') return;
      root.dataset.catalogueFiltersBound = 'true';

      const inputs = Array.from(root.querySelectorAll('[data-catalogue-filter]'));
      const stateKey = root.closest('[data-discovery-section]')?.dataset.sectionId || 'catalogue';
      const savedSelection = catalogueFilterState.get(stateKey);
      if (savedSelection) inputs.forEach((input) => {
        input.checked = savedSelection.includes(`${input.dataset.catalogueFilter}:${input.value}`);
      });
      const cards = Array.from(root.querySelectorAll('[data-catalogue-product]'));
      const clearButton = root.querySelector('[data-catalogue-clear]');
      const status = root.querySelector('[data-catalogue-filter-status]');
      const toggle = root.querySelector('[data-catalogue-toggle]');
      const panel = root.querySelector('[data-catalogue-panel]');
      const activeCount = root.querySelector('[data-catalogue-active-count]');
      const phone = window.matchMedia('(max-width: 749px)');
      const updatePanel = () => {
        if (!root.isConnected) { phone.removeEventListener('change', updatePanel); return; }
        if (!toggle || !panel) return;
        toggle.hidden = !phone.matches;
        panel.hidden = phone.matches && toggle.getAttribute('aria-expanded') !== 'true';
      };
      toggle?.addEventListener('click', () => {
        toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true'));
        updatePanel();
      });
      phone.addEventListener('change', updatePanel);
      updatePanel();

      const applyFilters = () => {
        catalogueFilterState.set(stateKey, inputs.filter((input) => input.checked).map((input) => `${input.dataset.catalogueFilter}:${input.value}`));
        const selected = inputs.reduce((groups, input) => {
          if (input.checked && !input.disabled) groups[input.dataset.catalogueFilter].push(input.value);
          return groups;
        }, { gamme: [], forme: [], longueur: [] });

        let visibleCount = 0;
        cards.forEach((card) => {
          const matches = Object.entries(selected).every(([key, values]) => {
            if (values.length === 0) return true;
            const cardValues = (card.dataset[`catalogue${key[0].toUpperCase()}${key.slice(1)}`] || '').split('|');
            return values.some((value) => cardValues.includes(value));
          });
          card.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        if (status) status.textContent = `${visibleCount} ${status.dataset.resultLabel}`;
        const selectedCount = inputs.filter((input) => input.checked && !input.disabled).length;
        if (activeCount) activeCount.textContent = selectedCount ? `(${selectedCount})` : '';
      };

      inputs.forEach((input) => input.addEventListener('change', applyFilters));
      clearButton?.addEventListener('click', () => {
        inputs.forEach((input) => { input.checked = false; });
        applyFilters();
      });
      // Length belongs to the refill product on phones; keep desktop choices intact.
      const updateMobileLength = () => {
        if (!root.isConnected) {
          phone.removeEventListener('change', updateMobileLength);
          return;
        }
        const suppressLength = phone.matches && root.hasAttribute('data-catalogue-mobile-no-length');
        inputs.forEach((input) => {
          if (input.dataset.catalogueFilter === 'longueur') input.disabled = suppressLength;
        });
        applyFilters();
      };
      phone.addEventListener('change', updateMobileLength);
      updateMobileLength();
    });
  };

  bindCatalogueFilters();
  // Sorting replaces the results markup: bind the fresh filter controls too.
  document.querySelectorAll('[data-discovery-section]').forEach((section) => {
    if (!section.querySelector('[data-catalogue-filter-root]')) return;
    new MutationObserver(() => bindCatalogueFilters(section)).observe(section, { childList: true, subtree: true });
  });
  document.addEventListener('shopify:section:load', (event) => bindCatalogueFilters(event.target));

  } catch(e) { console.error(e); }
})();
})();
